<template>
  <div class="">
    <div class="relative w-auto" v-closable="closeMenu">
      <button
        class="px-2 py-1 rounded items-center system-button"
        :class="{ 'border border-primary-500': showBorder }"
        @click.prevent="showMenu = !showMenu"
      >
        <options-icon class="w-4 h-4 fill-current" />
      </button>

      <div
        v-show="showMenu"
        class="flex flex-col rounded bg-white absolute right-0 top-4 shadow z-50 text-content-500"
      >
        <button
          v-for="(option, index) in options"
          :key="index"
          :class="[
            'px-4 h-10 text-sm whitespace-nowrap smooth',
            {
              'bg-primary-300 bg-opacity-10 text-primary-500':
                action === option.action,
            },
          ]"
          @mouseover="action = option.action"
          @mouseleave="action = null"
          @click.prevent="
            showMenu = false;
            $emit(option.action);
          "
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OptionsIcon from "@/icons/OptionsIcon";
export default {
  name: "Options Menu",

  components: {
    OptionsIcon,
  },

  data() {
    return {
      action: null,
      showMenu: false,
    };
  },

  props: {
    options: Array,
    showBorder: Boolean
  },

  methods: {
    closeMenu() {
      this.showMenu = false;
    },
  },
};
</script>